import repository from "@/plugins/axios/secureClient";

const metaResource = "/meta";

export default {
  getMeta() {
    return repository.get(metaResource);
  }
};
